export default __webpack_public_path__ + "images/9e53dcf07c84055e5ee0d03309ab2d27.svg";